import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select/async";
import { getIndividuals } from "common/services/individuals.service";
import { normalize } from "common/lib/normalize";
import {
  GroupBase,
  OptionsOrGroups,
} from "react-select/dist/declarations/src/types";

const SelectIndividual = ({
  validation,
  isUpdate,
  selectedId,
}: {
  validation: any;
  isUpdate?: boolean;
  selectedId?: number;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.individual && validation.errors.individual
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.individual && validation.errors.individual
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let filters = {};
        if (isUpdate) {
          filters = {
            individual: selectedId,
          };
        }
        const response = await getIndividuals({
          pagination: {
            page: 1,
            pageSize: 20,
          },
          filters,
        });
        setData(normalize(response.data));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [isUpdate, selectedId]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.fullName}${
          el?.emailAddress ? " - " + el?.emailAddress : ""
        }${el?.passportOrIdNumber ? " - " + el?.passportOrIdNumber : ""}`,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label htmlFor="individual-field" className="form-label">
        Indivdual / Person
      </Label>
      <Select
        name="individual"
        id="individual"
        value={
          validation.values.individual.value
            ? validation.values.individual
            : null
        }
        placeholder="Select individual"
        validate={{
          required: { value: true },
        }}
        onChange={(value: any) => {
          validation.setFieldValue("individual", value);
          validation.setFieldError("individual", "");
        }}
        defaultOptions={options}
        // @ts-ignore
        loadOptions={(
          inputValue: string,
          callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
        ) => {
          return getIndividuals({
            pagination: {
              page: 1,
              perPage: 20,
            },
            filters: {
              $or: [
                {
                  fullName: {
                    $containsi: inputValue,
                  },
                },
              ],
            },
          }).then((result: any) => {
            const parsedData = normalize(result.data);
            callback(
              parsedData.map((el: any) => {
                return {
                  value: el?.id,
                  label: `${el?.fullName} ${
                    el?.emailAddress ? " - " + el?.emailAddress : ""
                  } ${
                    el?.passportOrIdNumber ? " - " + el?.passportOrIdNumber : ""
                  }`,
                };
              })
            );
          });
        }}
        onBlur={() => validation.setFieldTouched("individual", true)}
        className={
          validation.touched.individual && validation.errors.individual
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>{validation.errors.individual?.value}</FormFeedback>
    </FormGroup>
  );
};

export default SelectIndividual;
